import { render, staticRenderFns } from "./fattoriPolizze.vue?vue&type=template&id=c574f750&"
import script from "./fattoriPolizze.vue.ts?vue&type=script&lang=ts&"
export * from "./fattoriPolizze.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports